import React from 'react'

import ErrorComponent from '_components/error-component'

const NotFoundPage = () => <ErrorComponent />

export default NotFoundPage
